import React from 'react';
import classNames from 'classnames';

import CheckIcon from '../../../icons/core/check.svg?component';
import { RCCheckableLabel } from './RCCheckableLabel';
import { CommonInputProps } from '../../types';
import { RCIcon } from '../../';

export interface IRCCheckableProps extends Omit<CommonInputProps, 'helpText' | 'variant' | 'tag'> {
  /** Passed through to the input tag. */
  checked: boolean;

  /** Additional line of text below main label; sentence-case without ending punctuation. Not rendered if `variant` is set to `switch`. */
  sublabel?: string;
}

/** A styled checkbox element. Never use a default `<input type="checkbox">`, always use this. */
export function RCCheckbox({
  checked,
  disabled,
  errorText,
  id,
  label,
  name,
  onChange,
  required,
  sublabel = undefined,
}: IRCCheckableProps) {
  return (
    <span className={classNames(
      'rc-checkbox',
      { 'rc-checkbox--disabled': disabled },
    )}>
      <input
        className="rc-checkbox__input"
        type="checkbox"
        name={name}
        id={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        required={required}
      />
      <span className="rc-checkbox__box">
        <RCIcon svgComponent={CheckIcon} />
      </span>
      <RCCheckableLabel
        htmlFor={id}
        sublabel={sublabel}
        label={label}
        errorText={errorText}
      />
    </span>
  );
}
